module.exports = __webpack_public_path__ + "static/ruinsuk-e2b58e8b0c78643070e6289d7656f54e.png";